import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpRequest, HttpHandler,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { InitializeScriptService } from 'src/app/services/api/InitializeScript.service';

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {

  constructor(private tokenService: InitializeScriptService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(request.headers.has('x-api-key') && !request.headers.get('x-api-key')){
        request = request.clone({
            setHeaders: {
                'x-api-key': (request.url.includes('disrest')  ? this.tokenService.getConfig()?.tokenDetails?.dis : this.tokenService.getConfig()?.tokenDetails?.ui) ?? ''
            }
        });
    }
     return next.handle(request)    
  }
}